// REA-CI/screens/SellerHomeScreen.tsx

import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Ionicons } from '@expo/vector-icons';
import { StackNavigationProp } from '@react-navigation/stack';
import { RootStackParamList } from '../navigation/types'; // Adjust the path to your types file

type SellerHomeScreenNavigationProp = StackNavigationProp<RootStackParamList, 'SellerHomeScreen'>;

const SellerHomeScreen: React.FC = () => {
  const navigation = useNavigation<SellerHomeScreenNavigationProp>();

  const navigateToScreen = (screen: keyof RootStackParamList) => {
    if (navigation && navigation.navigate) {
      navigation.navigate(screen);
    } else {
      console.error(`Navigation failed: Screen "${screen}" not found.`);
    }
  };

  return (
    <ScrollView contentContainerStyle={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>Welcome to Seller Home</Text>
      </View>

      <View style={styles.section}>
        <TouchableOpacity
          style={styles.option}
          onPress={() => navigateToScreen('PostPropertyScreen')}
        >
          <Ionicons name="home-outline" size={24} color="#000" />
          <Text style={styles.optionText}>Post a Property</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.option}
          onPress={() => navigateToScreen('ListingsScreen')}
        >
          <Ionicons name="list-outline" size={24} color="#000" />
          <Text style={styles.optionText}>Manage Listings</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.option}
          onPress={() => navigateToScreen('MessagesScreen')}
        >
          <Ionicons name="chatbubble-outline" size={24} color="#000" />
          <Text style={styles.optionText}>Messages</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.option}
          onPress={() => navigateToScreen('SellerProfileScreen')}
        >
          <Ionicons name="person-outline" size={24} color="#000" />
          <Text style={styles.optionText}>Profile Settings</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: 16,
    backgroundColor: '#f9f9f9',
  },
  header: {
    alignItems: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
  },
  section: {
    flex: 1,
    marginTop: 10,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 16,
    marginBottom: 12,
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  optionText: {
    fontSize: 16,
    marginLeft: 12,
    color: '#333',
  },
});

export default SellerHomeScreen;
